module.exports = __webpack_public_path__ + "static/media/ic_mic_off.85a495eb.svg";